/**
 * Typography utility styles.
 */
import * as stylex from "@stylexjs/stylex";

import { colors, fontSize } from "../tokens.stylex";

export const text = stylex.create({
  white: { color: colors.foreground },
  muted: { color: colors.foregroundMuted },
  error: { color: colors.destructive },
  success: { color: colors.success },
  warning: { color: colors.warning },
  center: { textAlign: "center" },
  sm: { fontSize: fontSize.sm },
  xs: { fontSize: fontSize.xs },
  lg: { fontSize: fontSize.lg },
  xl: { fontSize: fontSize.xl },
  "2xl": { fontSize: fontSize["2xl"] },
  "3xl": { fontSize: fontSize["3xl"] },
  "4xl": { fontSize: fontSize["4xl"] },
  bold: { fontWeight: 700 },
  semibold: { fontWeight: 600 },
  medium: { fontWeight: 500 },
  mono: { fontFamily: "monospace" },
  capitalize: { textTransform: "capitalize" },
  truncate: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
